// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 744 ? "actioncable" : chunkId) + "-" + {"715":"3af10a188c64c5510560","744":"2878a1f6d66a3445ad9f"}[chunkId] + ".chunk.js";
};